module.exports = __webpack_public_path__ + "static/img/bg-es.6eed8ab2.png";